import React, { Component } from 'react'
import Drawer from 'material-ui/Drawer'
import MenuItem from 'material-ui/MenuItem'
import { logo, title } from '../config/constants'
const activeItemStyle = { backgroundColor: 'rgba(0, 0, 0, 0.2)' }

class SideNavBrand extends Component {
  render() {
    return (
      <div style={{
        borderBottom: '1px solid #eee',
        margin: '10%',
        textAlign: 'center',
        width: '80%'
      }}>
        <img
          role='presentation'
          src={this.props.logo}
          style={{
            width: '60%'
          }}
        />
        <h1 style={{ marginTop: '0' }}>{this.props.title}</h1>
      </div>
    )
  }
}

class SideNavLink extends Component {
  render() {
    return (
      <MenuItem
        onClick={() => {
          this.props.push(this.props.path)
          if (this.props.mobileMode) {
            this.props.toggleNav(false)
          }
        }}
        style={this.props.pathname.indexOf(this.props.path) === 0 ? activeItemStyle : {}}
      >
        {this.props.title}
      </MenuItem>
    )
  }
}

export default class SideNav extends Component {
  render() {
    return (
      <Drawer
        docked={!this.props.mobileMode}
        open={this.props.open}
        onRequestChange={open => this.props.toggleNav(open)}
      >
        <SideNavBrand logo={logo} title={title} />
        <SideNavLink {...this.props} title='Dashboard' path='/dashboard' />
        <SideNavLink {...this.props} title='Risk Register' path='/risks' />
      </Drawer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SideNav.js